module.exports = __webpack_public_path__ + "static/media/5.8849720f.jpg";